import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PageService {
  private apiUrl = environment.apiUrl; // Adjust the base URL as necessary

  constructor(private http: HttpClient) { }

  getPage(pageCode: string): Observable<any> {
    var page = this.http.get(`${this.apiUrl}Pages/GetPage/${pageCode}`
    );
    return page;
  }
  getPageByUrl(url: string): Observable<any> {
    var page = this.http.get(`${this.apiUrl}Pages/GetPageByUrl/${btoa(encodeURIComponent(url))}`
    );
    return page;
  }

}
